import { FormInstance, useWatch } from 'antd/es/form/Form';

interface UsePriceSessionInfoProps {
  form: FormInstance;
  collectionSessionInfo?: any;
  triggeredFromTask?: boolean;
  taskData?: any;
}

export function usePriceSessionInfo({
  form,
  collectionSessionInfo,
  triggeredFromTask = false,
  taskData,
}: UsePriceSessionInfoProps) {
  // Watch live form values from Ant Design form
  const liveDate = useWatch('date', form);
  const liveTypeOfPosition = useWatch('typeOfPosition', form);
  const liveEstablishment = useWatch('establishment', form);
  const liveEstablishmentOther = useWatch('establishmentOther', form);

  // Combine live form values with collectionSessionInfo state and taskData fallbacks
  const date =
    liveDate?.toString() ||
    collectionSessionInfo?.date?.toString() ||
    (taskData?.assignmentDate ? String(taskData.assignmentDate) : undefined);

  const typeOfPosition =
    liveTypeOfPosition ||
    collectionSessionInfo?.typeOfPosition ||
    taskData?.establishmentType;

  const establishment =
    liveEstablishment ||
    collectionSessionInfo?.establishment ||
    taskData?.establishmentName;

  const establishmentOther =
    liveEstablishmentOther ||
    collectionSessionInfo?.establishmentOther;

  return {
    date,
    typeOfPosition,
    establishment,
    establishmentOther,
  };
}
